export enum Article {
  der = 'der',
  die = 'die',
  das = 'das',
  derdas = 'derdas',
  derdie = 'derdie',
  diedas = 'diedas'
}
